/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'getCustomerDealerPropertyBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_DEALER_PROPERTY_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/dealer-property/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_DEALER_PROPERTY,
    requestSchema: requestSchemas.customerDealerProperties.getCustomerDealerPropertyBySystemGameId,
  },
  {
    action: 'updateCustomerDealerPropertyById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_DEALER_PROPERTY_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/dealer-property/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_DEALER_PROPERTY,
    requestSchema: requestSchemas.customerDealerProperties.updateCustomerDealerPropertyById,
  },
];
